<template>
  <div class="bg-white overflow-hidden">

    <SnowflakeBackground />

    <Menu />

    <div class="relative mt-24 mx-auto max-w-screen-xl md:mt-28 lg:mt-32 xl:mt-36 lg:px-24">

      <transition
        enter-active-class="duration-200 ease-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-100 ease-in"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >

        <router-view class="transition" />

      </transition>

    </div>

    <Footer />

  </div>
</template>

<script>
import Menu from './components/Menu.vue';
import SnowflakeBackground from './components/SnowflakeBackground.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Menu,
    SnowflakeBackground,
    Footer
  }
}
</script>
